/* Community Playtomic (port di community.js) — gruppi, contatti, suggeriti, in comune. */
import { useEffect, useState } from "react";
import { ptapp } from "@/lib/ptapp";
import { Card, AccountSelect, COORD, asList } from "./_ui";

const pickName = (o: any) => o.full_name || o.name || o.display_name || o.title || ((o.first_name || "") + " " + (o.last_name || "")).trim() || (o.user && (o.user.full_name || o.user.name)) || "Senza nome";
const pickUid = (o: any) => o.user_id || o.id || o.uid || o.player_id || (o.user && (o.user.user_id || o.user.id)) || null;
const pickLevel = (o: any) => { const lv = o.level_value ?? o.level ?? (o.user && o.user.level_value); return lv != null ? "Lv " + (Math.round(lv * 100) / 100) : null; };

function PlayerCard({ acct, o }: { acct: string; o: any }) {
  const uid = pickUid(o); const lvl = pickLevel(o);
  const extra = o.matches_played != null ? o.matches_played + " partite" : (o.common_matches != null ? o.common_matches + " in comune" : "");
  const [st, setSt] = useState<"" | "ok" | "err" | "..">("");
  const follow = async () => { if (!uid) return; setSt(".."); try { await ptapp.call(acct, "app", "v1/social/users/me/follow/" + uid, { method: "POST" }); setSt("ok"); } catch { setSt("err"); } };
  return (
    <div className="rounded-lg border border-slate-200 p-2.5">
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0"><div className="truncate text-sm font-semibold text-slate-800">{pickName(o)}</div><div className="text-xs text-slate-400">{[lvl, extra].filter(Boolean).join(" · ")}</div></div>
        {uid ? <button onClick={follow} disabled={st === "ok" || st === ".."} className="shrink-0 rounded-md border border-slate-300 px-2 py-1 text-xs font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-60">{st === "ok" ? "✓ seguito" : st === ".." ? "…" : st === "err" ? "errore" : "segui"}</button> : null}
      </div>
    </div>
  );
}

function Sec({ acct, title, loader, kind }: { acct: string; title: string; loader: () => Promise<unknown>; kind: "group" | "player" }) {
  const [data, setData] = useState<any[] | null>(null);
  const [err, setErr] = useState("");
  useEffect(() => { let a = true; setData(null); setErr(""); loader().then((d) => a && setData(asList(d))).catch((e) => a && setErr(e.message)); return () => { a = false; }; }, [acct]);
  return (
    <Card title={title}>
      {data == null ? <div className="text-sm text-slate-500">carico…</div> : err ? <div className="text-sm text-red-600">Errore: {err}</div> :
        data.length === 0 ? <div className="text-sm text-slate-500">Nessun risultato.</div> : (
          <div className="grid gap-2" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))" }}>
            {data.map((g: any, i: number) => kind === "group"
              ? <div key={i} className="rounded-lg border border-slate-200 p-2.5"><div className="text-sm font-semibold text-slate-800">{g.name || g.title || "Gruppo"}</div><div className="text-xs text-slate-400">{g.members_count != null ? g.members_count + " membri" : (g.type || "")}</div></div>
              : <PlayerCard key={i} acct={acct} o={g} />)}
          </div>
        )}
    </Card>
  );
}

export default function Community() {
  const [acct, setAcct] = useState("moving");
  return (
    <div className="mx-auto max-w-5xl space-y-4 p-4">
      <div className="flex items-center gap-3"><h2 className="text-lg font-bold text-slate-900">Community</h2><AccountSelect value={acct} onChange={setAcct} /></div>
      <Sec key={acct + "g"} acct={acct} title="Gruppi / Community" kind="group" loader={() => ptapp.call(acct, "app", "v1/groups", { params: { user_id: "me" } })} />
      <Sec key={acct + "c"} acct={acct} title="Contatti" kind="player" loader={() => ptapp.call(acct, "app", "v1/contacts", { params: { owner_user_id: "me" } })} />
      <Sec key={acct + "s"} acct={acct} title="Giocatori suggeriti" kind="player" loader={() => ptapp.call(acct, "app", "v1/relations/suggested_players", { params: { coordinate: COORD, size: 50, suggestion_type: "FOLLOW", user_id: "me" } })} />
      <Sec key={acct + "k"} acct={acct} title="Giocatori in comune" kind="player" loader={() => ptapp.uid(acct).then((u) => ptapp.call(acct, "app", "v1/relations/common_match_players", { params: { user_id: u.uid, size: 20 } }))} />
    </div>
  );
}
